import React from "react";
import buildUrl from "build-url-ts";
import { replace } from "react-router-dom";

import {
  generateQueryParams,
  parseQueryParams,
} from "src/services/reports.service";

import Cell from "../cell";
import Timeseries from "../timseries";

import {
  ASSET,
  COLLECTION,
  USER,
  USER_GROUP,
  CONTACT,
} from "src/legacy/constants/entities";

import styles from "../styles.module.scss";

class UniqueViewersView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        reportDate: parseQueryParams(this.props.location.query),
        filters: [],
        userType: 'all'
      },
      showFilter: false,
      filters: this.props.filters,
      saveFilterView: false,
      filterName: "",
      filterId: null,
    };
  }

  componentDidMount() {
    this.setState(
      {
        filter: {
          ...this.state.filter,
          reportDate: parseQueryParams(this.props.location.query),
        },
      },
      () => {
        const url = this.generateReportUrl(
          this.props.location.pathname,
          this.state.filter.reportDate,
          this.state.filterId
        );
        replace(url);
      }
    );
  }

  generateReportUrl(url, reportDate, filterId) {
    const queryParams = generateQueryParams(reportDate, filterId);

    const query = {
      ...this.props.location.query,
      ...queryParams,
    };

    const updated = buildUrl(url, {
      queryParams: query,
    });

    return updated;
  }
  
  render() {
    return (
      <div className={styles.reports}>
        <div className={styles.grid}>
          <Cell>
            <Timeseries
              title={`# of unique viewers (${this.props.count})`}
              loading={this.props.loading}
              data={this.props.data}
              supportedEntities={[USER, USER_GROUP, ASSET, CONTACT, COLLECTION]}
              legend={{
                key: "Date",
                value: "Unique viewers",
              }}
              request={this.state.filter}
              fetchData={(request = this.state.filter) => {
                this.props.fetchEngagementUniqueViewersGraphReport(request);
              }}
            />
          </Cell>
        </div>
      </div>
    );
  }
}

export default UniqueViewersView;
